export default __webpack_public_path__ + "static/media/AddIcon.4464c9cd.svg";